module.exports={
	"Form": "ProductionPlantCreateManifest",
	"Scope": "ProductionPlant-Create",
	"Descriptors":
	{
		"ProductionPlantDetails.Name":
		{
			"Name": "Name",
			"Hash": "ProductionPlant-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "ProductionPlant-Create-Identity",
				"Group": "ProductionPlant-Create-Identity"
			}
		},
		"ProductionPlantDetails.IDOrganization":
		{
			"Name": "Organization",
			"Hash": "ProductionPlant-Create-IDOrganization",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "ProductionPlant-Create-Details",
				"Group": "ProductionPlant-Create-Details",
				"Entity": "Organization",
				"SearchFields":
				[
					"Name",
					"VendorCode",
					"FederalTaxCode"
				]
			}
		},
		"ProductionPlantDetails.IDOrganizationAddress":
		{
			"Name": "Organization Address",
			"Hash": "ProductionPlant-Create-IDOrganizationAddress",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "ProductionPlant-Create-Details",
				"Group": "ProductionPlant-Create-Details",
				"Entity": "OrganizationAddress",
				"SearchFields":
				[
					"LocationName"
				]
			}
		},
		"ProductionPlantDetails.Notes":
		{
			"Name": "Notes",
			"Hash": "ProductionPlant-Create-Notes",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "ProductionPlant-Create-Details",
				"Group": "ProductionPlant-Create-Details"
			}
		},
		"ProductionPlantDetails.ExternalProductionPlantID":
		{
			"Name": "External Production Plant ID",
			"Hash": "ProductionPlant-Create-ExternalProductionPlantID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "ProductionPlant-Create-Details",
				"Group": "ProductionPlant-Create-Details"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "ProductionPlant-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "ProductionPlant-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "ProductionPlant-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "ProductionPlant-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
